<template>
  <span>
    <font-awesome-icon
      :id="id"
      icon="info-circle"
      style="cursor: pointer"
      class="text-black-25"
    />
    <b-popover :target="id" triggers="click blur" placement="bottom">
      <template #title>{{title}}</template>
      <div v-html="markdownToHtml"></div>
    </b-popover>
  </span>
</template>

<script>
import { marked } from 'marked';

export default {
  name: 'InlineHelp',
  props: {
    id: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
    description: {
      type: String,
      required: true,
    },
  },
  computed: {
    markdownToHtml() {
      return marked.parse(this.description);
    },
  },
};
</script>

<style scoped></style>
